import { Colors, CommonLabel, FlexBox } from "@brg/ui";
import { FC, useCallback, useMemo } from "react";
import { WrappedFieldProps } from "redux-form";
import { GridRow } from "../../../../CompetitionApplicationForm/components/styles";
import { FormLabel } from "../../../../../modals/styles";
import { LabelRedStar } from "../../../../designerEditView/styles";
import styled from "styled-components";
import { LayoutConst } from "core";

export const InputContainer = styled(FlexBox)`
  width: 100%;
  position: relative;

  .date-input {
    padding: 16px 16px 13px 16px;

    &:disabled {
        color: #909090 !important;
    }
  }

      input, textarea, .date-input {
          background-color: ${Colors.galBlack5} !important;
          border-color: transparent !important;
          color: ${Colors.galBlack47};
          font-size: 15px;
          line-height: 20px;
  
          &:hover {
              border-color: transparent !important;
          }
          &:focus {
            border-color: transparent !important;
            box-shadow: none !important;
            outline: none !important;
          }
  
          &::placeholder {
              color: ${Colors.galBlack47};
          }
      }
  
      input, .date-input  {
          height: 48px !important;
          width: 100%;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.02em;
          max-width: 700px !important;
          width: 700px !important;

          @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 40px !important;
            width: 552px !important;
            min-width: 552px !important;
            max-width: 552px !important;
          }

          @media(max-width: ${LayoutConst.screen.m}px) {
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
          }
          
      }

          @media(max-width: ${LayoutConst.screen.md}px) {

          }
  
          @media(max-width: ${LayoutConst.screen.s}px) {
              width: 100%;
  
            }
   
      @media(max-width: ${LayoutConst.screen.md}px) {
          input, .date-input  {
              height: 40px !important;
          }
      }
  
      @media(max-width: ${LayoutConst.screen.s}px) {
          input, .date-input  {
              height: 40px !important;
          }
      }
`;

interface BilingualTextInputProps extends WrappedFieldProps {
  label: string;
  required?: boolean;
  multiline?: boolean;
  maxLength?: number;
  onChange: (data: any) => void;
}

const DateInput: FC<BilingualTextInputProps> = ({
  input, 
  meta,
  label,
  input: {
    onChange,
    value: inputValue,
  },
  required,
  multiline,
  maxLength,
  ...props
}) => {
    const handleChange = useCallback(({ target: { value } }: any) => {
      onChange(value);
    }, [onChange]);

    const maxDate = useMemo(() =>  {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }, [])

  return (
    <GridRow align="center" style={{ placeItems: 'center' }} isTeamEdit fullWidth mobileColumn>
      <CommonLabel 
        label={label}
        required={required}
      />
      {/* <FormLabel isTeamEdit>
        {label}
        {required && (
          <LabelRedStar>*</LabelRedStar>
        )}
      </FormLabel> */}
      <InputContainer direction="column" directionMobile="column" className={'input-container'}>
        <input 
          type="date"
          className="date-input"
          max={maxDate}              
          {...input}
          {...props}
          onChange={handleChange}
        />
      </InputContainer>
    </GridRow>
  )
}

export default DateInput;import { Colors, CommonLabel, FlexBox } from "@brg/ui";
import { FC, useCallback, useMemo } from "react";
import { WrappedFieldProps } from "redux-form";
import { GridRow } from "../../../../CompetitionApplicationForm/components/styles";
import { FormLabel } from "../../../../../modals/styles";
import { LabelRedStar } from "../../../../designerEditView/styles";
import styled from "styled-components";
import { LayoutConst } from "core";

export const InputContainer = styled(FlexBox)`
  width: 100%;
  position: relative;

  .date-input {
    padding: 16px 16px 13px 16px;

    &:disabled {
        color: #909090 !important;
    }
  }

      input, textarea, .date-input {
          background-color: ${Colors.galBlack5} !important;
          border-color: transparent !important;
          color: ${Colors.galBlack47};
          font-size: 15px;
          line-height: 20px;
  
          &:hover {
              border-color: transparent !important;
          }
          &:focus {
            border-color: transparent !important;
            box-shadow: none !important;
            outline: none !important;
          }
  
          &::placeholder {
              color: ${Colors.galBlack47};
          }
      }
  
      input, .date-input  {
          height: 48px !important;
          width: 100%;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.02em;
          max-width: 700px !important;
          width: 700px !important;

          @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 40px !important;
            width: 552px !important;
            min-width: 552px !important;
            max-width: 552px !important;
          }

          @media(max-width: ${LayoutConst.screen.m}px) {
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
          }
          
      }

          @media(max-width: ${LayoutConst.screen.md}px) {

          }
  
          @media(max-width: ${LayoutConst.screen.s}px) {
              width: 100%;
  
            }
   
      @media(max-width: ${LayoutConst.screen.md}px) {
          input, .date-input  {
              height: 40px !important;
          }
      }
  
      @media(max-width: ${LayoutConst.screen.s}px) {
          input, .date-input  {
              height: 40px !important;
          }
      }
`;

interface BilingualTextInputProps extends WrappedFieldProps {
  label: string;
  required?: boolean;
  multiline?: boolean;
  maxLength?: number;
  onChange: (data: any) => void;
}

const DateInput: FC<BilingualTextInputProps> = ({
  input, 
  meta,
  label,
  input: {
    onChange,
    value: inputValue,
  },
  required,
  multiline,
  maxLength,
  ...props
}) => {
    const handleChange = useCallback(({ target: { value } }: any) => {
      onChange(value);
    }, [onChange]);

    const maxDate = useMemo(() =>  {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }, [])

  return (
    <GridRow align="center" style={{ placeItems: 'center' }} isTeamEdit fullWidth mobileColumn>
      <CommonLabel 
        label={label}
        required={required}
      />
      {/* <FormLabel isTeamEdit>
        {label}
        {required && (
          <LabelRedStar>*</LabelRedStar>
        )}
      </FormLabel> */}
      <InputContainer direction="column" directionMobile="column" className={'input-container'}>
        <input 
          type="date"
          className="date-input"
          max={maxDate}              
          {...input}
          {...props}
          onChange={handleChange}
        />
      </InputContainer>
    </GridRow>
  )
}

export default DateInput;